<template>
  <require from="controls/as-form-section.html"></require>
  <require from="framework/value_converters/date-and-time"></require>

  <as-form-section heading="Change History" if.bind="history != null && history.length > 0">
    <div slot="body">
      <table class="table table-borderless table-striped sc-table-fixed">
        <thead>
          <tr>
            <th class="d-none d-sm-table-cell" width="150px">Change</th>
            <th class="d-none d-sm-table-cell">Description</th>
            <th class="d-sm-none">Change</th>
            <th width="180px" class="d-none d-lg-table-cell">Status</th>
            <th width="29px" class="d-lg-none"></th>
          </tr>
        </thead>
        <tbody>
          <tr repeat.for="record of history">
            <td class="text-wrap">
              <span class="d-sm-none">${record.comment}</span>
              <span class="d-sm-none d-block text-muted" title="${record.createdOn | dateTime} by ${record.createdBy.name}">${record.createdOn | dateTime} by ${record.createdBy.name}</span>
              <span class="d-none d-sm-block" title="${record.createdOn | dateTime}">${record.createdOn | dateTime}</span>
              <span class="d-none d-sm-block text-muted" title=" by ${record.createdBy.name}">by ${record.createdBy.name}</span>
            </td>
            <td class="d-none d-sm-table-cell text-wrap" title="${record.comment}">
              <span>${record.comment}</span>
              <span class="text-muted d-block text-wrap" title="Assigned to ${record.assignedTo.name}">Assigned to ${record.assignedTo.name}</span>
            </td>
            <td title="${record.status.name}" class="d-none d-lg-table-cell">
              <div class="d-flex justify-content-between">
                <span class="text-truncate at-deviation-request-status ${record.statusClass}">${record.status.name}</span>
                <i class="ai-deviation-request-status ${record.statusClass}"></i>
              </div>
            </td>
            <td title="${record.status.name}" class="d-lg-none">
              <i class="ai-deviation-request-status ${record.statusClass}"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </as-form-section>
</template>
